import { render, staticRenderFns } from "./portraitSummary.vue?vue&type=template&id=1fdf4c64&scoped=true"
import script from "./portraitSummary.vue?vue&type=script&lang=js"
export * from "./portraitSummary.vue?vue&type=script&lang=js"
import style0 from "./portraitSummary.vue?vue&type=style&index=0&id=1fdf4c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf4c64",
  null
  
)

export default component.exports